// removed by extract-text-webpack-plugin
module.exports = {"Modal":"styles__Modal___1bipT","ModalTitle":"styles__ModalTitle___2Q1IU","Separator":"styles__Separator___JsP4D","LanguageList":"styles__LanguageList___1vgmy","LanguageItem":"styles__LanguageItem___258TI","Text":"styles__Text___2xFzT","Country":"styles__Country___1rekv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Language/styles.scss
// module id = 1425
// module chunks = 0